/**
 * @generated SignedSource<<74d96d9ee114e6918bfaa0f984d93911>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type sharedMessageHelpers_expiringPromotion$data = {
  readonly " $fragmentSpreads": FragmentRefs<"expiringPromoMessageHelpers_expiringPromotion">;
  readonly " $fragmentType": "sharedMessageHelpers_expiringPromotion";
};
export type sharedMessageHelpers_expiringPromotion$key = {
  readonly " $data"?: sharedMessageHelpers_expiringPromotion$data;
  readonly " $fragmentSpreads": FragmentRefs<"sharedMessageHelpers_expiringPromotion">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "sharedMessageHelpers_expiringPromotion"
};

(node as any).hash = "925f9835008643739f14499a6546d9b2";

export default node;
